
export const PRODUCT_TABLE_ACCESSORS = {
    PRODUCT_IMAGE: "product_image",
    PRODUCT_NAME: "product_name",
    PRODUCT_SKU: "product_sku",
    PRODUCT_QUANTITY: "product_quantity"
}

